import { useCallback, useState } from 'react';

import { fieldsOf, messageOf } from './api';

/**
 * One form action at a time: `busy` while it runs, and the error it ended with
 * (a message, plus per-field problems when the API named them).
 */
export function useRunner() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fields, setFields] = useState<Record<string, string>>({});

  const run = useCallback(async (action: () => Promise<void>): Promise<boolean> => {
    setBusy(true);
    setError(null);
    setFields({});
    try {
      await action();
      return true;
    } catch (e) {
      setError(messageOf(e));
      setFields(fieldsOf(e));
      return false;
    } finally {
      setBusy(false);
    }
  }, []);

  const fail = useCallback((message: string, fieldErrors: Record<string, string> = {}) => {
    setError(message);
    setFields(fieldErrors);
  }, []);

  return { busy, error, fields, run, fail };
}
